export enum LanguageEnum {
  SPANISH = "es",
  ENGLISH = "en",
  PORTUGUESE = "pt",
}

type ApplePayLocale = "en-US" | "es-ES" | "es-MX" | "pt-BR";

export const LanguageToAppleCode: Record<string, ApplePayLocale> = {
  [LanguageEnum.SPANISH]: "es-MX",
  [LanguageEnum.PORTUGUESE]: "pt-BR",
  [LanguageEnum.ENGLISH]: "en-US",
};
